import { render } from "./AgentsListStep.vue?vue&type=template&id=ecdf23de&scoped=true"
import script from "./AgentsListStep.vue?vue&type=script&lang=ts"
export * from "./AgentsListStep.vue?vue&type=script&lang=ts"

import "./AgentsListStep.vue?vue&type=style&index=0&id=ecdf23de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ecdf23de"

export default script